import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import { getHasSavedResults } from 'ctm-selectors/selectors/results';
import { apiAction, pageContext, getRulesFromState, get, haveRulesChanged } from 'ctm-util-functions';
import { quoteIdSelector, resultsConfigSelector } from 'ctm-selectors';
import { getFeatureFlag } from 'ctm-selectors/selectors/base';
import { InternalLink } from '../../internal_link/internal_link';
import * as actions from '../actions';
import styles from './results_link.css';

class _ResultsLink extends Component {

    /**
     * Determine if the component should re-render based on the nextState
     * @param  {Object} nextProps  The incoming set of props
     * @returns {Boolean} true if the component should re-render
     */
    shouldComponentUpdate = (nextProps) => {
        const { quoteId, visualProps } = this.props;
        return haveRulesChanged(nextProps, this.props)
            || nextProps.quoteId !== quoteId
            || nextProps.visualProps !== visualProps;
    };

    componentDidMount = () => {
        const { dispatch } = this.props;
        const hasSavedResults = getHasSavedResults() || getFeatureFlag('prefillHasSavedResults');
        // Due to re-rendering we need to make sure we only dispatch this function once
        if (hasSavedResults &&  window.dataLayer && !window.dataLayer.find((item) => item.actionStep === 'car results' || item.actionStep === 'home_contents results'))  dispatch({ type: 'PREFILL_SAVED_RESULTS' });
    };

    /**
     *
     * @param {Object} event The event object
     */
    handleClick = (event) => {
        const { rules = {}, dispatch, eventProps, stateProps, api, quoteId } = this.props;
        // @todo: make this nicer, need a better way to check for the existence of non-required rules
        if (get(rules, 'disabled.result')) {
            event.preventDefault();
            return;
        }

        // @todo EVT-481 this whole method should be abstracted as its called from multiple places.
        const productId = get(stateProps, 'product.productMeta.id');
        dispatch(actions.setProductId(productId));
        dispatch(actions.setQuoteId(quoteId));

        // Dispatch any other onClick action defined in schema
        if (get(eventProps, 'onClick')) {
            dispatch(eventProps.onClick);
        } else if (Array.isArray(eventProps.onClickActions)) {
            eventProps.onClickActions.forEach((action) => dispatch(action));
        }

        if (api) {
            // @todo: revisit how to use internal link in react-router 4, if we want api to handle the redirect
            // we shouldn't need to pass # to the <Link /> it causes the router to go to the start page
            // it really should be <Link to={null} /> in this case
            if (!get(this.props, 'elementProps.href', false)) {
                event.preventDefault();
            }
            dispatch(apiAction(api, pageContext.getProps().pageState));
        }
    };

    /**
     * Construct and return a unique data-id attribute value for this resultsLink, using elementProps.dataIdBase
     * and the productId for this link
     * @returns {String} - The value for the data-id attribute
     * @private
     */
    _getDataId = () => {
        const { stateProps, elementProps } =  this.props;
        // eslint-disable-next-line react/destructuring-assignment
        if (this.props['data-id']) {
            // eslint-disable-next-line react/destructuring-assignment
            return this.props['data-id'];
        }

        const productId = stateProps.product.getIn(['productMeta', 'id']);
        const baseId = elementProps.dataIdBase;
        return `${baseId}.${productId}`;
    };

    render = () => {
        const {
            children,
            contentProps,
            visualProps,
            elementProps,
            stateProps
        } = this.props;

        const isVisible = get(this.props, 'rules.visibility.result', true);
        if (!stateProps.product.get('productMeta') || !isVisible) {
            return null;
        }

        const href = get(this.props, 'elementProps.href', '#');
        const hasSavedResults = getHasSavedResults() || getFeatureFlag('prefillHasSavedResults');
        const vertical = pageContext.getVertical();

        return (
            hasSavedResults ? (
                <p>
                    Additional excess may apply.
                    <br />
                    Please refer to PDS
                </p>
            )
                : (
                    <InternalLink
                        {...elementProps}
                        {...visualProps}
                        {...contentProps}
                        data-id={this._getDataId()}
                        href={href}
                        className={styles[`variant_${get(this.props, 'visualProps.variant')}`]}
                        onClick={this.handleClick}
                    >
                        {children}
                    </InternalLink>
                )
        );
    };

}

_ResultsLink.propTypes = {
    contentProps: PropTypes.object,
    eventProps: PropTypes.object,
    stateProps: PropTypes.shape({
        product: PropTypes.instanceOf(Immutable.Map)
    }),
    visualProps: PropTypes.object,
    elementProps: PropTypes.object,
    api: PropTypes.object,
    dispatch: PropTypes.func,
    children: PropTypes.node,
    rules: PropTypes.object,
    quoteId: PropTypes.number,
    dispatchGtmEvent: PropTypes.func,
    'data-id': PropTypes.string
};

_ResultsLink.defaultProps = {
    stateProps: {
        product: Immutable.Map()
    }
};

const mapStateToProps = (state, props) => {
    const quoteId = quoteIdSelector(state) || 0;
    return {
        quoteId,
        rules: getRulesFromState(state, props)
    };
};

const ResultsLink = connect(mapStateToProps)(_ResultsLink);

export { ResultsLink, _ResultsLink };
